import styled from 'styled-components';
import { v2Color } from '@theme/v2';

// --- List body states ---
export const SkeletonGrid = styled.div`
  display: grid;
  gap: 10px;
  padding: 16px 24px;
`;

export const StatePad = styled.div`
  padding: 24px;
`;

export const ListGrid = styled.div`
  display: grid;
  gap: 10px;
  padding: ${({ $isMobile }) => ($isMobile ? 4 : 16)}px ${({ $sidePad }) => $sidePad}px 16px;
`;

// --- Desktop assist view ---
export const AssistPanel = styled.div`
  display: flex;
  flex-direction: column;
  max-height: ${({ $isMobile }) => ($isMobile ? '88vh' : '82vh')};
`;

export const AssistHeaderDesktop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: ${({ $isMobile }) => ($isMobile ? 14 : 16)}px ${({ $sidePad }) => $sidePad}px;
  border-block-end: 1px solid #f0f0f0;
`;

export const AssistHeaderLeft = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  background: transparent;
  border: 0;
  color: ${v2Color('#006169', 'text')};
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
`;

export const HeaderDivider = styled.span`
  width: 1px;
  height: 18px;
  background: rgba(5, 5, 5, 0.1);
`;

export const AssistHeaderTitle = styled.span`
  color: rgba(0, 0, 0, 0.88);
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
`;

export const CloseButton = styled.button`
  display: inline-grid;
  place-content: center;
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  padding: 0;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: rgb(112, 112, 112);
  cursor: pointer;
`;

export const AssistBody = styled.div`
  flex: 1;
  min-height: ${({ $isMobile }) => ($isMobile ? 0 : 480)}px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

// --- List view ---
export const ListPanel = styled.div`
  display: flex;
  flex-direction: column;
  height: ${({ $isMobile }) => ($isMobile ? 'calc(100vh - 60px)' : '82vh')};
`;

export const ListHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: ${({ $isMobile, $sidePad }) =>
    $isMobile ? `16px ${$sidePad}px` : `15px ${$sidePad}px 20px`};
  border-block-end: 1px solid #f0f0f0;
`;

export const ListTitleGroup = styled.span`
  display: inline-flex;
  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
  align-items: ${({ $isMobile }) => ($isMobile ? 'flex-start' : 'center')};
  gap: ${({ $isMobile }) => ($isMobile ? 8 : 0)}px;
  min-width: 0;
`;

export const ListTitle = styled.h2`
  margin: 0;
  font-size: ${({ $isMobile }) => ($isMobile ? 16 : 18)}px;
  line-height: ${({ $isMobile }) => ($isMobile ? '22px' : '24px')};
  font-weight: 700;
  color: rgba(0, 0, 0, 0.88);
`;

export const ChipDivider = styled.span`
  display: inline-flex;
  align-items: center;
  margin-inline-start: 14px;
  padding-inline-start: 14px;
  border-inline-start: 1px solid #edeff2;
`;

export const MobileActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px ${({ $sidePad }) => $sidePad}px 4px;
  background: #fafbfc;
`;

export const FilterIconButton = styled.button`
  display: inline-grid;
  place-content: center;
  flex: 0 0 auto;
  margin-inline-start: auto;
  width: 40px;
  height: 40px;
  padding: 0;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  cursor: pointer;
`;

export const DesktopFiltersBar = styled.div`
  padding: 14px ${({ $sidePad }) => $sidePad}px;
  border-block-end: 1px solid #f5f5f5;
`;

export const ListScroll = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  background: #fafbfc;
`;

export const ListFooter = styled.div`
  display: flex;
  align-items: center;
  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
  justify-content: space-between;
  gap: 16px;
  padding: 12px ${({ $sidePad }) => $sidePad}px;
  border-block-start: 1px solid #f0f0f0;
  flex-wrap: wrap;
`;

export const ShowingText = styled.span`
  font-size: ${({ $isMobile }) => ($isMobile ? 12 : 13)}px;
  color: rgb(112, 112, 112);
`;

// --- Mobile assist sheet ---
export const AssistSheet = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 88vh;
`;

export const SheetHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px ${({ $sidePad }) => $sidePad}px;
  border-block-end: 1px solid #f0f0f0;
`;

export const SheetTitle = styled.span`
  color: rgba(0, 0, 0, 0.88);
  font-size: 16px;
  font-weight: 700;
`;

export const SheetBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

// --- Mobile filter sheet ---
export const FilterSheet = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 82vh;
`;

export const FilterBody = styled.div`
  padding: 16px ${({ $sidePad }) => $sidePad}px;
  overflow-y: auto;
`;

export const FilterFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px ${({ $sidePad }) => $sidePad}px;
  border-block-start: 1px solid #f0f0f0;
`;
